import { TFunction } from '@lyearn/i18n';
import { PropertiesToDuplicateEnum } from '@/types/schema';

export const getPropertiesToDuplicateOptions = (t: TFunction) => [
  {
    label: t('Task:DuplicationProperties.DueDate'),
    value: PropertiesToDuplicateEnum.DueDate,
  },
  {
    label: t('Task:DuplicationProperties.Assignees'),
    value: PropertiesToDuplicateEnum.Assignees,
  },
  {
    label: t('Task:DuplicationProperties.Status'),
    value: PropertiesToDuplicateEnum.Status,
  },
  {
    label: t('Task:DuplicationProperties.Tags'),
    value: PropertiesToDuplicateEnum.Tags,
  },
  {
    label: t('Task:DuplicationProperties.Subtasks'),
    value: PropertiesToDuplicateEnum.SubTasks,
  },
  {
    label: t('Task:DuplicationProperties.Stages'),
    value: PropertiesToDuplicateEnum.Stages,
  },
  {
    label: t('Task:DuplicationProperties.Linkage'),
    value: PropertiesToDuplicateEnum.Task,
  },
  {
    label: t('Task:DuplicationProperties.Priority'),
    value: PropertiesToDuplicateEnum.Priority,
  },
];
